import { useTranslate } from "@similarweb/i18n-provider";

import type { CrmIntegrationProvider } from "app/pages/sales-intelligence/domain/crm-integration/types/provider";
import { getCrmName } from "app/pages/sales-intelligence/utils/crm";

import { StyledInfoWrapper, StyledText, StyledTitle } from "./styles";

type Props = {
    integrationProvider: CrmIntegrationProvider;
    matchedCount: number;
    totalCount: number;
};

const HeaderContent = ({ integrationProvider, matchedCount, totalCount }: Props) => {
    const { translate } = useTranslate();

    const crmName = getCrmName(integrationProvider);

    return (
        <StyledInfoWrapper data-automation="crm-records-matched-info">
            <StyledTitle>{translate("si.table.sub-table.header.crm.title", { provider: crmName })}</StyledTitle>
            <StyledText>
                {translate("si.table.sub-table.header.crm.records-count", { matchedCount, totalCount })}
            </StyledText>
        </StyledInfoWrapper>
    );
};

export default HeaderContent;
